import React, { useEffect, useState } from 'react'
import { Space, Table, Flex } from 'antd';
import Main from '../../../cpn/Main';
import LoanTypeEdit from './LoanTypeEdit';    
import LoanTypeAdd from './LoanTypeAdd';
import { useJiekuanlxListQuery } from '../../../store/DianShangYeWuApi';
import LoanTypeDel from './LoanTypeDel';
function LoanTypeList() {
    const [list, setList] = useState();    
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))   
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useJiekuanlxListQuery({jklx_qy_id:qy_id,});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {jklx_id:key,jklx_name,jklx_uname,jklx_ctime} = item;                 
                    return item = {key,jklx_name,jklx_uname,jklx_ctime}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.yh_ctime;
                    let bTimeString = b.yh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'fklx_name',           
            title: '名称',            
            dataIndex: 'jklx_name',
        },              
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space align='center' size='middle'>
                        <LoanTypeEdit
                            jklx_id={record.key} 
                            jklx_name={record.jklx_name} 
                            qy_id={qy_id}
                            qy_name={qy_name}
                            yh_id={yh_id}
                            yh_name={yh_name}
                        />
                        <LoanTypeDel
                                jklx_id={record.key}
                        />
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main selectedKeys={['/LoanTypeList']}>                       
            <Flex>
                <LoanTypeAdd 
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                className="custom-table"
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
            />
        </Main>
    )
}

export default LoanTypeList
